import React, { useState,useEffect } from "react";
import axios from "axios";
import { getCookie } from "../../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
const apiUrl1 = process.env.REACT_APP_ASSETS_API_URL;
const apiUrl2 = process.env.REACT_APP_ADMIN_API_URL;
const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getDeleteGate = async (gateId) => {
 
  try {
    const response = await axios.delete(
      apiUrl+`gate/delete/`+gateId,
      {
        headers: header,
      }
    );
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getGateDetailsApi = async (gateId) => { 
  try {
    const response = await axios.get(
      apiUrl+`gate/get/`+gateId,
      {
        headers: header,
      }
    );
return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateGateApi = async (data,gateId) => {  
  try {
    const response = await axios.put(
      apiUrl+`/gate/`+gateId,data, { headers: header });
return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response
  } finally {
  }
};

 
 